import localDB from "./localDB";
let GLOBAL = require('./globals');

const StorePaymentData = {
    async get(res) {
        await fetch(`${GLOBAL.BASE_URL}store-payments`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}store-payments`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    }
};

export default StorePaymentData;


// WEBPACK FOOTER //
// ./src/data/StorePaymentData.js